module.exports = __webpack_public_path__ + "static/media/(V)-Prata-06.16104533.jpg";